const MEDIA = '/media';

export const eventUrls = {
  privateDentistryAwards:
    'https://awards.dentistry.co.uk/privatedentistryawards/en/page/home',
  privateDentistryTickets:
    'https://awards.dentistry.co.uk/privatedentistryawards/en/page/ticket-table-packages',
  dsoAwards: 'https://awards.dentistry.co.uk/dsoawards/en/page/home',
  adgConference: 'https://adg2027.dentistry.co.uk/',
  futureOfDentistry: 'https://future.dentistry.co.uk/',
} as const;

export interface UpcomingEvent {
  name: string;
  category: 'Conference' | 'Awards' | 'Summit';
  date: string;
  venue: string;
  ctaLabel: string;
  href: string;
  image: string;
}

export const upcomingEvents: UpcomingEvent[] = [
  {
    name: 'Private Dentistry Awards',
    category: 'Awards',
    date: '20 November 2026',
    venue: 'JW Marriott Grosvenor House, London',
    ctaLabel: 'Book your table',
    href: eventUrls.privateDentistryTickets,
    image: `${MEDIA}/images/private-dentistry-awards-2026.webp`,
  },
  {
    name: 'Dentistry DSO Awards',
    category: 'Awards',
    date: '11 December 2026',
    venue: 'Underglobe, London',
    ctaLabel: 'Learn more',
    href: eventUrls.dsoAwards,
    image: `${MEDIA}/images/dentistry-dso-awards-2026.webp`,
  },
];

export interface HeroSlide {
  eyebrow: string;
  name: string;
  venue: string;
  ctaLabel: string;
  href: string;
  image: string;
  position?: string;
}

export const heroSlides: HeroSlide[] = [
  {
    eyebrow: 'Ceremony · 11 December 2026',
    name: 'Dentistry DSO Awards',
    venue: 'Underglobe, London',
    ctaLabel: 'Buy your ticket',
    href: eventUrls.dsoAwards,
    image: `${MEDIA}/hero/dentistry-dso-awards-2026.jpg`,
    position: 'center',
  },
  {
    eyebrow: 'Ceremony · 20 November 2026',
    name: 'Private Dentistry Awards',
    venue: 'JW Marriott Grosvenor House, London',
    ctaLabel: 'Buy your ticket',
    href: eventUrls.privateDentistryTickets,
    image: `${MEDIA}/hero/private-dentistry-awards-2026.webp`,
  },
  {
    eyebrow: 'Register your interest · 1–2 July 2027',
    name: 'ADG Conference 2027',
    venue: 'De Vere Cotswold Water Park',
    ctaLabel: 'Register your interest',
    href: eventUrls.adgConference,
    image: `${MEDIA}/hero/adg-conference-2027.webp`,
  },
];

export interface ComingEvent {
  name: string;
  side: 'left' | 'right';
  image?: string;
  tile?: string;
  date?: string;
  venue?: string;
  inviteOnly?: boolean;
  ctaLabel: string;
  href?: string;
}

export const comingSoon2027: ComingEvent[] = [
  {
    name: 'Future of Dentistry Summit: Implant Edition',
    side: 'left',
    image: `${MEDIA}/images/future-of-dentistry-implants-2027.jpg`,
    date: '28 January 2027',
    venue: 'Courthouse Hotel Shoreditch, London',
    inviteOnly: true,
    ctaLabel: 'More info',
    href: eventUrls.futureOfDentistry,
  },
  {
    name: 'Future of Dentistry Summit: Orthodontics Edition',
    side: 'right',
    image: `${MEDIA}/images/future-of-dentistry-orthodontics-2027.jpg`,
    date: '4 March 2027',
    venue: 'Courthouse Hotel Shoreditch, London',
    inviteOnly: true,
    ctaLabel: 'More info',
    href: eventUrls.futureOfDentistry,
  },
  {
    name: 'Future of Dentistry Summit: Digital Dentistry',
    side: 'left',
    image: `${MEDIA}/images/future-of-dentistry-digital-dentistry-2027.jpg`,
    date: '22 April 2027',
    venue: 'Courthouse Hotel Shoreditch, London',
    inviteOnly: true,
    ctaLabel: 'More info',
    href: eventUrls.futureOfDentistry,
  },
  {
    name: 'Dental Industry Awards 2027',
    side: 'right',
    image: `${MEDIA}/images/dental-industry-awards-2027.jpg`,
    date: '14 May 2027',
    venue: 'Hilton Birmingham Metropole',
    ctaLabel: 'More info coming soon',
  },
  {
    name: 'ADG Conference 2027',
    side: 'left',
    image: `${MEDIA}/images/adg-conference-2027.webp`,
    date: '1–2 July 2027',
    venue: 'De Vere Cotswold Water Park',
    ctaLabel: 'More info',
    href: eventUrls.adgConference,
  },
  {
    name: 'Future of Dentistry Summit: Prevention Edition',
    side: 'right',
    image: `${MEDIA}/images/future-of-dentistry-prevention-2027.jpg`,
    date: '16 September 2027',
    venue: 'Courthouse Hotel Shoreditch, London',
    inviteOnly: true,
    ctaLabel: 'More info',
    href: eventUrls.futureOfDentistry,
  },
  {
    name: 'Future of Dentistry Summit: Rising Stars Edition',
    side: 'left',
    image: `${MEDIA}/images/future-of-dentistry-rising-stars-2027.jpg`,
    date: '7 October 2027',
    venue: 'Courthouse Hotel Shoreditch, London',
    inviteOnly: true,
    ctaLabel: 'More info',
    href: eventUrls.futureOfDentistry,
  },
  {
    name: 'Private Dentistry Awards 2027',
    side: 'right',
    image: `${MEDIA}/images/private-dentistry-awards-2027.jpg`,
    date: '19 November 2027',
    venue: 'JW Marriott Grosvenor House, London',
    ctaLabel: 'More info coming soon',
  },
  {
    name: 'Dentistry DSO Awards 2027',
    side: 'left',
    image: `${MEDIA}/images/dentistry-dso-awards-2027.jpg`,
    ctaLabel: 'More details coming soon',
  },
];

export const siteLinks = [
  { label: 'Private Dentistry Awards', href: eventUrls.privateDentistryAwards },
  { label: 'Dentistry DSO Awards', href: eventUrls.dsoAwards },
  { label: 'Future of Dentistry Summit', href: eventUrls.futureOfDentistry },
  { label: 'ADG Conference', href: eventUrls.adgConference },
];
